import { Users, Trophy, Briefcase, ScanLine, Wallet, BarChart3, ShieldCheck, Clock, Building2, Handshake, Sparkles, Target, Rocket, Star, CreditCard, Dumbbell, QrCode } from 'lucide-react';

export const ICON_OPTIONS = [
  { key: 'users', label: 'لاعبون / مستخدمون', Icon: Users },
  { key: 'trophy', label: 'كأس / بطولات', Icon: Trophy },
  { key: 'briefcase', label: 'موظفون / حقيبة', Icon: Briefcase },
  { key: 'scan', label: 'مسح / باركود', Icon: ScanLine },
  { key: 'wallet', label: 'مالية / محفظة', Icon: Wallet },
  { key: 'chart', label: 'تقارير / رسم بياني', Icon: BarChart3 },
  { key: 'shield', label: 'أمان / حماية', Icon: ShieldCheck },
  { key: 'clock', label: 'وقت / سرعة', Icon: Clock },
  { key: 'building', label: 'منشأة / مبنى', Icon: Building2 },
  { key: 'handshake', label: 'شراكة', Icon: Handshake },
  { key: 'star', label: 'نجمة / تميز', Icon: Sparkles },
  { key: 'target', label: 'هدف', Icon: Target },
  { key: 'rocket', label: 'انطلاق', Icon: Rocket },
  { key: 'award', label: 'تقييم', Icon: Star },
  { key: 'card', label: 'دفع', Icon: CreditCard },
  { key: 'dumbbell', label: 'تدريب / عمل فني', Icon: Dumbbell },
  { key: 'qrcode', label: 'بطاقات / رمز QR', Icon: QrCode },
];

export const getLandingIcon = (key) => (ICON_OPTIONS.find((o) => o.key === key) || ICON_OPTIONS[0]).Icon;

export default ICON_OPTIONS;
